import { ExtractionStatus, type SuretyAccountId } from "@inrev/common";
import { useFetchFinancialExtractions } from "@portal/api/financials";
import { useFetchWipExtractions } from "@portal/api/wip";

export const usePendingExtractions = (accountId: SuretyAccountId) => {
	const { financialExtractions } = useFetchFinancialExtractions(accountId);
	const { wipExtractions } = useFetchWipExtractions(accountId);

	const hasPendingFinancial =
		financialExtractions?.some((extraction) => extraction.status === ExtractionStatus.Pending) ??
		false;
	const hasPendingWip =
		wipExtractions?.some((extraction) => extraction.status === ExtractionStatus.Pending) ?? false;

	return {
		hasPendingFinancial,
		hasPendingWip,
		hasPendingExtractions: hasPendingFinancial || hasPendingWip,
	};
};
